import { watchImageLoad } from "@/scripts/utils"; 

export default class ResponsiveImage extends HTMLElement {
  constructor() {
    super();

    // Vars
    const picture = this.querySelector("picture");
    const img = this.querySelector("img");

    // If image is not 'lazy', still fade in on loaded state
    if (!img.classList.contains("lazyload")) {
      watchImageLoad(picture)
        .then(() => {
          img.classList.add("loaded");
        })
        .catch(console.log);
    }
  }
}
